import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Fade from 'Components/Transitions/Fade';

export default function MultiActionAreaCard() {
  return (
    <Fade
      timeout={3000}
      sensorProps={{
        partialVisibility: true,
      }}
    >
      <Card sx={{ maxWidth: 345, height: '100%' }}>
        <CardActionArea>
          <CardMedia
            component="img"
            image="https://s3.us-west-2.amazonaws.com/www.tenspacesoftware.com/images/_4ba308ff-026a-4f9e-8651-3c9bd6363670.jpg"
            alt="floating round datacenter"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              Cloud Computing
            </Typography>
            <Typography variant="body2" color="text.secondary">
              We can help with all aspects of cloud computing, including automated build pipelines,
              lift and shift existing hardware into the cloud, create hybrid cloud infrastructure to
              integrate with your on-premiseinfrastructure, or perform create native cloud software
              development.
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button size="small" color="primary">
            Learn More
          </Button>
        </CardActions>
      </Card>
    </Fade>
  );
}
